import { Inquiry } from '../models/inquiry.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { WeeklyReportResponse } from '../models/weekly-report.model';

@Injectable({ providedIn: 'root' })
export class WeeklyReportService {
  private baseUrl = `${environment.apiUrl}/weeklyReports`;

  constructor(private http: HttpClient) {}

  getAll(ad: number, isAdmin: boolean = false, orCreate = false): Observable<WeeklyReportResponse> {
    const params = new HttpParams().set('isAdmin', String(isAdmin)).set('orCreate', String(orCreate));
    return this.http.get<WeeklyReportResponse>(`${this.baseUrl}/${ad}`, { params });
  }

  getLatestAd(isAdmin: boolean = false) {
    const params = new HttpParams().set('isAdmin', String(isAdmin));
    return this.http.get<number>(`${this.baseUrl}/latestAd`, { params });
  }

  store(data: WeeklyReportResponse) {
    return this.http.post(`${this.baseUrl}`, data);
  }
}
